import { render, staticRenderFns } from "./ForumThreadDetailView.vue?vue&type=template&id=986aa86e&scoped=true&"
import script from "./ForumThreadDetailView.vue?vue&type=script&lang=js&"
export * from "./ForumThreadDetailView.vue?vue&type=script&lang=js&"
import style0 from "./ForumThreadDetailView.vue?vue&type=style&index=0&id=986aa86e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "986aa86e",
  null
  
)

export default component.exports